import React, { useEffect } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { BsCaretLeftFill, BsCaretRightFill } from 'react-icons/bs';

import PerfectScrollBar from 'react-perfect-scrollbar';

import { maxBy, minBy } from 'lodash';

import { translate } from 'react-i18next';
import { formatDate, numberFormat } from '../../../../utils';
import HistoryChart from '../../../hightchart/historyChart';

const History = ({ loadStockHis, symbol, stockHis, t }) => {
  const [typeHistory, setTypeHistory] = React.useState('1m');
  const [isPc, setIsPc] = React.useState(false);

  const _handleLoadStockHis = (type) => {
    setTypeHistory(type);
    loadStockHis(type);
  };

  useEffect(() => {
    _handleLoadStockHis(typeHistory);
  }, [symbol]);

  // const { stockHis, t } = props;

  const _maxBy = maxBy(stockHis, 'high');
  const _minBy = minBy(stockHis, 'low');

  return (
    <div className="tab-history">
      <HistoryChart stockHis={stockHis} />
      <div className="d-flex justify-content-between">
        <ButtonGroup className="mr-2" aria-label="First group">
          <Button
            variant="secondary"
            className={typeHistory === '1w' ? 'active' : ''}
            onClick={() => _handleLoadStockHis('1w')}
          >
            1W
          </Button>{' '}
          <Button
            variant="secondary"
            className={typeHistory === '1m' ? 'active' : ''}
            onClick={() => _handleLoadStockHis('1m')}
          >
            1M
          </Button>{' '}
          <Button
            variant="secondary"
            className={typeHistory === '3m' ? 'active' : ''}
            onClick={() => _handleLoadStockHis('3m')}
          >
            3M
          </Button>{' '}
          <Button
            variant="secondary"
            className={typeHistory === '6m' ? 'active' : ''}
            onClick={() => _handleLoadStockHis('6m')}
          >
            6M
          </Button>{' '}
          <Button
            variant="secondary"
            className={typeHistory === '1y' ? 'active' : ''}
            onClick={() => _handleLoadStockHis('1y')}
          >
            1Y
          </Button>
        </ButtonGroup>

        <ButtonGroup aria-label="First group">
          <Button
            variant="secondary"
            className="bg-light"
            style={{ border: '1px solid #c4c9d0' }}
          >{`${t('txt-highest')}: ${numberFormat(
            _maxBy && _maxBy.high,
            2
          )}`}</Button>{' '}
          <Button
            variant="secondary"
            className="bg-light"
            style={{ border: '1px solid #c4c9d0' }}
          >{`${t('txt-lowest')}: ${numberFormat(
            _minBy && _minBy.low,
            2
          )}`}</Button>
        </ButtonGroup>
      </div>
      <PerfectScrollBar
        style={{ height: 'calc( 100vh - 544px )' }}
        className="mt-2"
      >
        <table className="table table-borderless">
          <thead>
            <tr>
              <th>{t('txt-time')}</th>
              <th>{t('txt-opened')}</th>
              <th>{t('txt-high')}</th>
              <th>{t('txt-low')}</th>
              <th>{t('txt-closed')}</th>
              <th>{t('txt-total-vol')}</th>
              <th className="position-relative">
                <BsCaretLeftFill
                  className="tbl-toggle-left"
                  onClick={() => setIsPc(!isPc)}
                />
                {isPc ? '%' : '+/-'}
                <BsCaretRightFill
                  className="tbl-toggle-right"
                  onClick={() => setIsPc(!isPc)}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {stockHis &&
              !!stockHis.length &&
              stockHis.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{formatDate(item.time, '-')}</td>
                  <td className="text-center">{numberFormat(item.open, 2)}</td>
                  <td className="text-center">{numberFormat(item.high, 2)}</td>
                  <td className="text-center">{numberFormat(item.low, 2)}</td>
                  <td className="text-center">{numberFormat(item.close, 2)}</td>
                  <td className="text-center">{numberFormat(item.vol, 0)}</td>
                  {isPc ? (
                    <td className={'text-center ' + item.color}>
                      {numberFormat(item.change, 2)}
                    </td>
                  ) : (
                    <td className={'text-center ' + item.color}>
                      {numberFormat(item.change_pc, 2)}
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </PerfectScrollBar>
    </div>
  );
};

export default translate('translations')(History);
